// Card.component.tsx
import React from "react";
import "./Card.style.css";
import useQuestion from "../../hooks/useQuestion";

const Card: React.FC = React.memo(() => {
  const { question } = useQuestion();

  return (
    <div
      key={question.id}
      className="card"
      data-testid="card"
      data-id={question.id}
    >
      <img
        src={`${process.env.PUBLIC_URL}${question.image}`}
        alt={`Card ${question.id}`}
        className={`card-image ${question.category}`}
      />
    </div>
  );
});

export default Card;
